<template>
	<div class="samples content-page">
		<section class="samples__section">
			<h2 class="samples__title">Tooltip container</h2>
			<p class="samples__example-title">Tooltip on icon info</p>
			<br />
			<section class="samples__sub-section">
				<TooltipContainer
					:tooltip="'Tooltip string'"
					:position="'top-start'"
				>
					<template #container>
						<Button
							:className="'btn--icon-only-circle'"
							labelText=""
							iconClassName="icon-info"
							:iconBeforeLabel="true"
						/>
					</template>
				</TooltipContainer>
				<br />
			</section>
			<p class="samples__example-title">Tooltip on toggle</p>
			<br />
			<section class="samples__sub-section">
				<TooltipContainer
					:tooltip="'Tooltip string'"
					:position="'right-start'"
				>
					<template #container>
						<Toggle>
							<template slot="true-value">on</template>
							<template slot="false-value">off</template>
						</Toggle>
					</template>
				</TooltipContainer>
				<br />
			</section>
			<p class="samples__example-title">Tooltip on flyout</p>
			<br />
			<section class="samples__sub-section">
				<div>
					<Button
						class="btn--primary"
						labelText="Tooltip container flyout"
						:btnClick="tooltipcontainerFlyout"
					/>
					<Flyout
						:title="'Tooltip Container Flyout'"
						:parentTag="'form'"
						:display="showTooltipcontainerFlyout"
						:novalidate="'novalidate'"
						@show="closeTooltipcontainerFlyout"
					>
						<template #flyout-content>
							<p>Tooltip on icon info</p>
							<br />
							<TooltipContainer
								:tooltip="'Tooltip string'"
								:position="'top-start'"
							>
								<template #container>
									<Button
										:className="'btn--icon-only-circle'"
										labelText=""
										iconClassName="icon-info"
										:iconBeforeLabel="true"
									/>
								</template>
							</TooltipContainer>
						</template>

						<template #flyout-footer>
							<ButtonGroup
								:items="[
									{
										btnClick: closeTooltipcontainerFlyout,
										className: 'btn--primary',
										labelText: 'Ok'
									},
									{
										btnClick: closeTooltipcontainerFlyout,
										className: 'btn btn--link',
										labelText: 'Cancel'
									}
								]"
							/>
						</template>
					</Flyout>
				</div>
				<br />
			</section>
		</section>
		<section class="samples__section typography-section">
			<h2 class="samples__title">Typography</h2>
			<br /><br />
			<span class="typography-section__heading-sm">Heading Small</span>
			<br /><br />
			<span class="typography-section__heading-md">Heading Medium</span>
			<br /><br />
			<span class="typography-section__heading-lg">Heading Large</span>
			<br /><br /><br />
			<span class="typography-section__sub-heading">Subheading</span>
			<br /><br /><br />
			<span class="typography-section__bd-txt-sm">Body Text Small</span>
			<br /><br />
			<span class="typography-section__bd-txt-sm-supporting"
				>Body Text Small Supporting</span
			>
			<br /><br />
			<span class="typography-section__bd-txt-regular"
				>Body Text Regular</span
			>
			<br /><br />
			<span class="typography-section__bd-txt-regular-emphasis"
				>Body Text Regular Emphasis</span
			>
			<br /><br />
			<span class="typography-section__bd-txt-lg">Body Text Large</span>
			<br /><br />
		</section>

		<section class="samples__section scrollbar-section">
			<h2 class="samples__title">Scrollbar</h2>
			<section class="samples__sub-section scrollbar-section__default">
				<h2 class="samples__title">Default</h2>
				<p>
					Lorem ipsum dolor sit amet, consectetur adipisicing elit,
					sed do eiusmod tempor incididunt ut labore et dolore magna
					aliqua. Ut enim ad minim veniam, quis nostrud exercitation
					ullamco laboris nisi ut aliquip ex ea commodo consequat.
					Duis aute irure dolor in reprehenderit in voluptate velit
					esse cillum dolore eu fugiat nulla pariatur. Excepteur sint
					occaecat cupidatat non proident, sunt in culpa qui officia
					deserunt mollit anim id est laborum.
				</p>

				<p>
					Lorem ipsum dolor sit amet, consectetur adipisicing elit,
					sed do eiusmod tempor incididunt ut labore et dolore magna
					aliqua. Ut enim ad minim veniam, quis nostrud exercitation
					ullamco laboris nisi ut aliquip ex ea commodo consequat.
					Duis aute irure dolor in reprehenderit in voluptate velit
					esse cillum dolore eu fugiat nulla pariatur. Excepteur sint
					occaecat cupidatat non proident, sunt in culpa qui officia
					deserunt mollit anim id est laborum.
				</p>

				<p>
					Lorem ipsum dolor sit amet, consectetur adipisicing elit,
					sed do eiusmod tempor incididunt ut labore et dolore magna
					aliqua. Ut enim ad minim veniam, quis nostrud exercitation
					ullamco laboris nisi ut aliquip ex ea commodo consequat.
					Duis aute irure dolor in reprehenderit in voluptate velit
					esse cillum dolore eu fugiat nulla pariatur. Excepteur sint
					occaecat cupidatat non proident, sunt in culpa qui officia
					deserunt mollit anim id est laborum.
				</p>
			</section>

			<section class="samples__sub-section scrollbar-section__white">
				<h2 class="samples__title">White</h2>
				<p>
					Lorem ipsum dolor sit amet, consectetur adipisicing elit,
					sed do eiusmod tempor incididunt ut labore et dolore magna
					aliqua. Ut enim ad minim veniam, quis nostrud exercitation
					ullamco laboris nisi ut aliquip ex ea commodo consequat.
					Duis aute irure dolor in reprehenderit in voluptate velit
					esse cillum dolore eu fugiat nulla pariatur. Excepteur sint
					occaecat cupidatat non proident, sunt in culpa qui officia
					deserunt mollit anim id est laborum.
				</p>

				<p>
					Lorem ipsum dolor sit amet, consectetur adipisicing elit,
					sed do eiusmod tempor incididunt ut labore et dolore magna
					aliqua. Ut enim ad minim veniam, quis nostrud exercitation
					ullamco laboris nisi ut aliquip ex ea commodo consequat.
					Duis aute irure dolor in reprehenderit in voluptate velit
					esse cillum dolore eu fugiat nulla pariatur. Excepteur sint
					occaecat cupidatat non proident, sunt in culpa qui officia
					deserunt mollit anim id est laborum.
				</p>

				<p>
					Lorem ipsum dolor sit amet, consectetur adipisicing elit,
					sed do eiusmod tempor incididunt ut labore et dolore magna
					aliqua. Ut enim ad minim veniam, quis nostrud exercitation
					ullamco laboris nisi ut aliquip ex ea commodo consequat.
					Duis aute irure dolor in reprehenderit in voluptate velit
					esse cillum dolore eu fugiat nulla pariatur. Excepteur sint
					occaecat cupidatat non proident, sunt in culpa qui officia
					deserunt mollit anim id est laborum.
				</p>
			</section>
			<br />
		</section>

		<section class="samples__section csv-section">
			<h2 class="samples__title">CSV Export Demo</h2>
			<div class="csv-export-demo">
				<Button
					labelText="Export CSV"
					class="btn--primary"
					:btnClick="exportCsv"
				/>
			</div>
		</section>

		<section class="samples__sub-section">
			<section class="samples__section">
				<h2 class="samples__title">Time Picker</h2>
				<section class="samples__sub-section">
					<TimePicker
						:labelText="'Label Text on time picker'"
						v-model="timer1"
					/>
					the time without seconds is => {{ timer1 }}
					<br />

					<TimePicker
						:labelText="'Label Text on time picker 2'"
						v-model="timer2"
					/>
					the time without seconds is => {{ timer2 }}
					<br />
				</section>
			</section>
		</section>
		<section class="samples__sub-section">
			<section class="samples__section">
				<h2 class="samples__title">Field Input</h2>
				<section class="samples__sub-section">
					<FieldInput
						:labelText="'Label Text on field input'"
						:helpText="'helpText example'"
						:required="true"
						v-model="fieldInputText"
					/>
					<br />
				</section>
			</section>
		</section>

		<section class="samples__section jsonpatch-section">
			<h2 class="samples__title">JsonPatch Demo</h2>
			<p>
				<a
					href="https://www.rfc-editor.org/rfc/rfc6902"
					target="_blank"
				>
					JSON Patch
				</a>
				defines a JSON document structure for expressing a sequence of
				operations to apply to a JavaScript Object Notation (JSON)
				document; it is suitable for use with the HTTP PATCH method. The
				"application/json-patch+json" media type is used to identify
				such patch documents
			</p>
			<div class="jsonpatch-demo">
				<h2 class="samples__title">PATCH</h2>
				<div>
					<div>
						<strong>
							Original Json
						</strong>
						<pre>
							{{ initialCreatePatchObj }}
						</pre
						>
					</div>
					<div>
						<strong>
							Original Json with Changes
						</strong>
						<pre>{{ modifiedCreatePatchObj }}</pre>
					</div>
					<div>
						<strong>
							Original Json Patched
						</strong>
						<pre>{{ this.initialObjPatched }}</pre>
					</div>
				</div>
				<Button
					class="btn--primary"
					labelText="Patch"
					:btnClick="jsonPatchUsingCreatePath"
				/>
				<strong>Response from API</strong>
				<pre>
					{{ jsonPatchResult }}
				</pre
				>
			</div>
		</section>

		<section class="samples__section">
			<h2 class="samples__title">Fieldsets</h2>

			<section class="samples__sub-section">
				<h2 class="samples__title">
					Checkbox group - Default Orentation
				</h2>

				<Fieldset :legend="'Check your preferences'">
					<template #fieldset-content>
						<CheckboxGroup
							:items="checkboxItems"
							:title="'Check your preferences'"
							:displayResults="true"
							v-model="checkboxGroupList"
						/>
					</template>
				</Fieldset>

				<br />
				<br />

				<h2 class="samples__title">full width</h2>
				<Fieldset
					:legend="'Check your preferences'"
					:variant="'fieldset--full-width'"
				>
					<template #fieldset-content>
						<CheckboxGroup
							:items="checkboxItems"
							:title="'Check your preferences'"
							:displayResults="true"
							v-model="checkboxGroupList"
						/>
					</template>
				</Fieldset>

				<br />
				<br />

				<h2 class="samples__title">no border</h2>
				<Fieldset
					:legend="'Check your preferences'"
					:variant="'fieldset--no-borders'"
				>
					<template #fieldset-content>
						<CheckboxGroup
							:items="checkboxItems"
							:title="'Check your preferences'"
							:displayResults="true"
							v-model="checkboxGroupList"
						/>
					</template>
				</Fieldset>

				<br />
				<br />

				<h2 class="samples__title">styled</h2>
				<Fieldset
					:legend="'Check your preferences'"
					:variant="'fieldset--styled'"
				>
					<template #fieldset-content>
						<CheckboxGroup
							:items="checkboxItems"
							:title="'Check your preferences'"
							:displayResults="true"
							v-model="checkboxGroupList"
						/>
					</template>
				</Fieldset>

				<br />
				<br />

				<h2 class="samples__title">
					Checkbox group - Vertical Orentation
				</h2>

				<Fieldset
					:legend="'Check your preferences'"
					:variant="'fieldset--vertical'"
				>
					<template #fieldset-content>
						<CheckboxGroup
							:items="checkboxItems"
							:title="'Check your preferences'"
							:displayResults="true"
							v-model="checkboxGroupList"
						/>
					</template>
				</Fieldset>

				<br />
				<br />

				<h2 class="samples__title">no border</h2>
				<Fieldset
					:legend="'Check your preferences'"
					:variant="'fieldset--vertical fieldset--no-borders'"
				>
					<template #fieldset-content>
						<CheckboxGroup
							:items="checkboxItems"
							:title="'Check your preferences'"
							:displayResults="true"
							v-model="checkboxGroupList"
						/>
					</template>
				</Fieldset>

				<br />
				<br />

				<h2 class="samples__title">styled vertical</h2>
				<Fieldset
					:legend="'Check your preferences'"
					:variant="'fieldset--vertical fieldset--styled'"
				>
					<template #fieldset-content>
						<CheckboxGroup
							:items="checkboxItems"
							:title="'Check your preferences'"
							:displayResults="true"
							v-model="checkboxGroupList"
						/>
					</template>
				</Fieldset>
			</section>

			<section class="samples__sub-section">
				<h2 class="samples__title">
					Radio group - Default Orentation
				</h2>

				<Fieldset :legend="'Lorem Ipsum'">
					<template #fieldset-content>
						<RadioButtonGroup
							:items="radiobuttonItems"
							v-model="radiobuttonItem"
						/>
					</template>
				</Fieldset>

				<br />
				<br />

				{{ radiobuttonItem }}

				<br />
				<br />

				<h2 class="samples__title">full width</h2>
				<Fieldset
					:legend="'Lorem Ipsum'"
					variant="fieldset--full-width"
				>
					<template #fieldset-content>
						<RadioButtonGroup
							:items="radiobuttonItems"
							v-model="radiobuttonItem"
						/>
					</template>
				</Fieldset>

				<br />
				<br />

				<h2 class="samples__title">no border</h2>
				<Fieldset
					:legend="'Lorem Ipsum'"
					variant="fieldset--no-borders"
				>
					<template #fieldset-content>
						<RadioButtonGroup
							:items="radiobuttonItems"
							v-model="radiobuttonItem"
						/>
					</template>
				</Fieldset>

				<br />
				<br />

				<h2 class="samples__title">styled</h2>
				<Fieldset :legend="'Lorem Ipsum'" variant="fieldset--styled">
					<template #fieldset-content>
						<RadioButtonGroup
							:items="radiobuttonItems"
							v-model="radiobuttonItem"
						/>
					</template>
				</Fieldset>

				<br />
				<br />

				<h2 class="samples__title">
					Radio group - Vertical Orentation
				</h2>
				<Fieldset :legend="'Lorem Ipsum'" variant="fieldset--vertical">
					<template #fieldset-content>
						<RadioButtonGroup
							:items="radiobuttonItems"
							v-model="radiobuttonItem"
						/>
					</template>
				</Fieldset>

				<br />
				<br />

				<h2 class="samples__title">no border</h2>
				<Fieldset
					:legend="'Lorem Ipsum'"
					variant="fieldset--vertical fieldset--no-borders"
				>
					<template #fieldset-content>
						<RadioButtonGroup
							:items="radiobuttonItems1"
							v-model="radiobuttonItem1"
						/>
					</template>
				</Fieldset>

				<br />
				<br />

				<p class="samples__text">value {{ radiobuttonItem1 }}</p>

				<br />
				<br />

				<h2 class="samples__title">styled</h2>
				<Fieldset
					:legend="'Lorem Ipsum'"
					variant="fieldset--vertical fieldset--styled"
				>
					<template #fieldset-content>
						<RadioButtonGroup
							:items="radiobuttonItems2"
							v-model="radiobuttonItem2"
						/>
					</template>
				</Fieldset>

				<br />
				<br />

				<p class="samples__text">value {{ radiobuttonItem2 }}</p>
			</section>
		</section>

		<section class="samples__section">
			<h2 class="samples__title">Split Input</h2>
			<section class="samples__sub-section">
				<!-- DEV: Each option should allow to write a placeholder in case there is a specific format needed. -->
				<SplitInput
					:splitOptions="[
						{
							text: 'Email',
							value: 'email',
							label: 'Email',
							placeholder: 'Please add your email',
							validations: {
								inputType: 'email',
								required: true
							}
						},
						{
							text: 'Phone',
							value: 'phonenumber',
							label: 'Phone Number',
							placeholder: '(555) 555 555',
							validations: {
								inputType: 'phonenumber',
								maxLength: 10,
								required: true
							}
						},
						{
							text: 'String',
							value: 'any text',
							label: 'Text',
							validations: {
								inputType: 'phonenumber',
								maxLength: 10,
								required: true
							}
						}
					]"
					:splitValue="'email'"
					v-model="splitInputValue"
				/>
				<span>{{ splitInputValue }}</span>
			</section>
		</section>

		<section class="samples__section">
			<h2 class="samples__title">Toggle Switch Groups</h2>

			<section class="samples__sub-section">
				<h2 class="samples__title">Horizontal</h2>
				<Fieldset
					:legend="'Select all of your favorite'"
					:legendBgColor="'#f5f9f7'"
				>
					<template #fieldset-content>
						<Toggle :label="'toggle lorem'" />
						<Toggle :label="'toggle ipsum'" />
						<Toggle :label="'toggle'" />
						<Toggle :label="'toggle'" />
					</template>
				</Fieldset>
			</section>
			<section class="samples__sub-section">
				<h2 class="samples__title">Vertical</h2>
				<Fieldset
					:legend="'Select all of your favorite'"
					:variant="'fieldset--vertical'"
				>
					<template #fieldset-content>
						<Toggle :label="'toggle lorem'" />
						<Toggle :label="'toggle ipsum'" />
						<Toggle :label="'toggle'" />
						<Toggle :label="'toggle'" />
					</template>
				</Fieldset>
			</section>
		</section>

		<section class="samples__section">
			<h2 class="samples__title">SearchFinder Component</h2>
			<span class="form-test__item">
				<SearchFinder v-model="codeLookUpSelected" :apiOptions="{}" />
			</span>
			<span>{{ codeLookUpSelected }}</span>
		</section>

		<section class="samples__section">
			<h2 class="samples__title">Result Toolbar Variants</h2>

			<section class="samples__sub-section">
				<h2 class="samples__title">Combo 1</h2>

				<div class="results-toolbar results-toolbar--variant-one">
					<div class="results-toolbar__search">
						<Search variant="toggle-icons" />
					</div>
					<div class="results-toolbar__counter">
						<ResultCounter />
					</div>
				</div>
			</section>

			<section class="samples__sub-section">
				<h2 class="samples__title">Combo 2</h2>

				<div class="results-toolbar results-toolbar--variant-two">
					<div class="results-toolbar__search">
						<Search variant="toggle-icons" />
					</div>

					<div class="results-toolbar__bulk">
						<Bulk />
					</div>
					<div class="results-toolbar__toggle">
						<Toggle :value="true">
							<template #true-value>on</template>
							<template #false-value>off</template>
						</Toggle>
					</div>
					<div class="results-toolbar__counter">
						<ResultCounter />
					</div>
					<div class="results-toolbar__select-all">
						<SelectAll />
					</div>
				</div>
			</section>

			<section class="samples__sub-section">
				<h2 class="samples__title">Combo 3</h2>

				<div class="results-toolbar results-toolbar--variant-three">
					<div class="results-toolbar__search">
						<Search
							variant="toggle-icons"
							placeholder="Search by placeholder"
						/>
					</div>

					<div class="results-toolbar__filter">
						<div class="results-toolbar__filter-buttons">
							<Button
								class="btn--link"
								:btnClick="() => {}"
								:labelText="'Restore Filters'"
								:name="'restore'"
							/>
						</div>
						<Dropdown
							:defaultValue="'All Forms'"
							:options="ddOptions(10)"
							v-model="dropdownValue1"
						/>
						<Dropdown
							:defaultValue="'All Forms'"
							:options="ddOptions(10)"
							v-model="dropdownValue1"
						/>
					</div>
					<div class="results-toolbar__counter">
						<ResultCounter />
					</div>
				</div>

				<br />

				<p class="samples__example-title">
					>NOTE: this example shows preselected fields when the
					Advanced Filters will be used.
				</p>

				<br />

				<div class="results-toolbar results-toolbar--variant-three">
					<div class="results-toolbar__search">
						<Search variant="toggle-icons" />
					</div>

					<div class="results-toolbar__filter">
						<div class="filter">
							<p class="filter__summary">
								<span class="filter__sumary-text">
									01/01/2022 - 01/15/2022 | Active ...
								</span>
							</p>
						</div>
						<div class="results-toolbar__filter-buttons">
							<Button
								class="btn--link"
								:btnClick="() => {}"
								:labelText="'Restore Filters'"
								:name="'restore'"
							/>
						</div>
					</div>

					<div class="results-toolbar__counter">
						<ResultCounter />
					</div>
				</div>
			</section>

			<section class="samples__sub-section">
				<h2 class="samples__title">Combo 4</h2>

				<div class="results-toolbar results-toolbar--variant-four">
					<div class="results-toolbar__bulk">
						<Bulk />
					</div>
					<div class="results-toolbar__counter">
						<ResultCounter />
					</div>
					<div class="results-toolbar__select-all">
						<SelectAll />
					</div>
				</div>
			</section>

			<section class="samples__sub-section">
				<h2 class="samples__title">Combo 5</h2>

				<div class="results-toolbar results-toolbar--variant-five">
					<div class="results-toolbar__filter">
						<div class="results-toolbar__filter-buttons">
							<Button
								class="btn--link"
								:btnClick="() => {}"
								:labelText="'Restore Filters'"
								:name="'restore'"
							/>
							<Dropdown
								:defaultValue="'All Forms'"
								:options="ddOptions(10)"
								v-model="dropdownValue1"
							/>
						</div>
					</div>
					<div class="results-toolbar__counter">
						<ResultCounter />
					</div>
				</div>
			</section>

			<section class="samples__sub-section">
				<h2 class="samples__title">Combo 6</h2>

				<div class="results-toolbar results-toolbar--variant-six">
					<div class="results-toolbar__bulk">
						<Bulk />
					</div>

					<div class="results-toolbar__filter">
						<div class="results-toolbar__filter-buttons">
							<Button
								class="btn--link"
								:btnClick="() => {}"
								:labelText="'Restore Filters'"
								:name="'restore'"
							/>
						</div>
						<Dropdown
							:defaultValue="'All Forms'"
							:options="ddOptions(10)"
							v-model="dropdownValue1"
						/>
						<Dropdown
							:defaultValue="'All Forms'"
							:options="ddOptions(10)"
							v-model="dropdownValue1"
						/>
					</div>
					<div class="results-toolbar__counter">
						<ResultCounter />
					</div>
					<div class="results-toolbar__select-all">
						<SelectAll />
					</div>
				</div>
			</section>

			<section class="samples__sub-section">
				<h2 class="samples__title">Combo 7</h2>

				<div class="results-toolbar results-toolbar--variant-seven">
					<div class="results-toolbar__search">
						<Search variant="toggle-icons" />
					</div>
					<div class="results-toolbar__sort">
						<DropdownSort />
					</div>
					<div class="results-toolbar__filter">
						<div class="results-toolbar__filter-buttons">
							<Button
								class="btn--link"
								:btnClick="() => {}"
								:labelText="'Restore Filters'"
								:name="'restore'"
							/>
						</div>
						<Dropdown
							:defaultValue="'All Forms'"
							:options="ddOptions(10)"
							v-model="dropdownValue1"
						/>
						<Dropdown
							:defaultValue="'All Forms'"
							:options="ddOptions(10)"
							v-model="dropdownValue1"
						/>
						<Dropdown
							:defaultValue="'All Forms'"
							:options="ddOptions(10)"
							v-model="dropdownValue1"
						/>
					</div>
					<div class="results-toolbar__counter">
						<ResultCounter />
					</div>
					<div class="results-toolbar__select-all">
						<SelectAll />
					</div>
				</div>
			</section>
		</section>

		<section class="samples__section">
			<h2 class="samples__title">Tables</h2>

			<section class="samples__sub-section">
				<h2 class="samples__title">Generic</h2>

				<Table :sourceObject="data2"></Table>
			</section>

			<section class="samples__sub-section">
				<h2 class="samples__title">with radiobuttons</h2>

				<Table :sourceObject="data2">
					<template #header-codeId="{ header }">
						<div
							class="card"
							style="background: white; border-radius: 4px; padding: 8px;"
						>
							{{ header }}
						</div>
					</template>

					<template #body-codeId="{ body }">
						<Radiobutton
							:labelText="body.codeId.toString()"
							:value="body.codeId"
						/>
					</template>
				</Table>
			</section>

			<section class="samples__sub-section">
				<h2 class="samples__title">with bulk actions</h2>

				<Table :sourceObject="data2" :tableMobilev1="true">
					<template #body-codeId>
						<Checkbox />
					</template>
				</Table>
			</section>

			<section class="samples__sub-section">
				<h2 class="samples__title">Variation 2</h2>

				<Table :sourceObject="data2" :tableMobilev2="true"></Table>
			</section>

			<section class="samples__sub-section">
				<h2 class="samples__title">
					Variation 1 Table w/ radio buttons
				</h2>

				<Table :sourceObject="data2" :tableMobilev1="true">
					<template #body-codeId="{ body }">
						<Radiobutton
							@onUpdateButton="selectedRow"
							:labelText="body.id"
						/>
					</template>
				</Table>
			</section>
		</section>

		<section class="samples__section">
			<h2 class="samples__title">Exporting Transactions</h2>

			<section class="samples__sub-section">
				<h2 class="samples__title">Format: JSON to CSV</h2>

				<Textarea
					label="Transactions"
					:cols="500"
					:maxLength="1565"
					:rows="10"
					:value="jsonDataTransactionsString"
				/>

				<h2 class="samples__title">Basic output Parameters</h2>

				<download-csv
					class="btn btn--primary"
					:data="jsonDataTransactions"
					name="filename.csv"
				>
					Download CSV
				</download-csv>
			</section>

			<section class="samples__sub-section">
				<h2 class="samples__title">Custom output Parameters</h2>

				<div>
					Fields: fields you want to export. <br />
					Labels: Set the label for the header row.
				</div>
				<br />
				<div>
					See doc reference:
					<a
						href="https://www.npmjs.com/package/vue-json-csv"
						class="link"
						>https://www.npmjs.com/package/vue-json-csv</a
					>
				</div>
				<br />
				<download-csv
					class="btn btn--primary"
					:data="jsonDataTransactions"
					:name="csvDataFile"
					:labels="transactionsColumns"
				>
					Download CSV {{ csvDataFile }}
				</download-csv>
			</section>
		</section>

		<br />
		<br />
		<hr />
		<br />
		<br />

		<!-- Components not working. -->

		<section class="samples__section">
			<h2 class="samples__title">Customer Navigation</h2>
			<section class="samples__sub-section">
				<p class="samples__text">Menu Functionality test buttons</p>
				<p class="samples__text">Hides/shows Customer Navigation bar</p>
				<Button
					id="defaultButton"
					labelText="Populate Company"
					:btnClick="this.populateCompany"
					type="Submit"
				/>
			</section>
		</section>

		<section class="samples__section">
			<h2 class="samples__title">
				Updates Site-Menu access to roles page
			</h2>
			<section class="samples__sub-section">
				<p class="samples__text">
					To test, you need to add/remove role in database
				</p>
				<p class="samples__text">
					Under aspnetAccessLogin, get Id from AspNetUsers and
					add/remove role in SupportUser_Role table
				</p>
				<br />
				<br />
			</section>
		</section>
		<section class="samples__section result toolbar">
			<h2 class="samples__title">Result Toolbar Component</h2>
			<ResultsToolbar :showBulkDiv="true">
				<template #left-container-above>
					<Search
						variant="toggle-icons"
						:timeout="300"
						placeholder="Search by user name or email"
					/>
					<DropdownSort
						:showClearSelectedButton="false"
						v-model="ddsValue"
						:options="ddsOptions"
					/>
				</template>
				<template #counter>
					<ResultCounter :counter="100" />
				</template>
			</ResultsToolbar>

			<ResultsToolbar :showBulkDiv="true">
				<template #left-container-above>
					<Search
						variant="toggle-icons"
						:timeout="300"
						placeholder="Search by user name or email"
					/>
					<DropdownSort
						:showClearSelectedButton="false"
						v-model="ddsValue"
						:options="ddsOptions"
					/>
				</template>
				<template #left-container-below>
					<Dropdown
						:defaultValue="'All Forms'"
						:options="ddOptions(10)"
						v-model="dropdownValue1"
					/>
				</template>
				<template #right-reset-btn>
					<Button labelText="Restore Filters" :btnClick="() => {}" />
				</template>
				<template #right-desk-container>
					<Dropdown
						:defaultValue="'All Forms'"
						:options="ddOptions(10)"
						v-model="dropdownValue1"
					/>
					<Dropdown
						:defaultValue="'All Forms'"
						:options="ddOptions(10)"
						v-model="dropdownValue1"
					/>
					<Dropdown
						:defaultValue="'All Forms'"
						:options="ddOptions(10)"
						v-model="dropdownValue1"
					/>
				</template>
				<template #counter>
					<ResultCounter :counter="100" />
				</template>
			</ResultsToolbar>

			<ResultsToolbar>
				<template #left-container-above>
					<Search
						variant="toggle-icons"
						:timeout="300"
						placeholder="Search by clients name or number"
					/>
					<DropdownSort
						:showClearSelectedButton="false"
						v-model="ddsValue"
						:options="ddsOptions"
					/>
				</template>
				<template #left-container-below>
					<Button
						labelText="Bulk Actions"
						class="btn--primary"
						:btnClick="() => {}"
				/></template>
				<template #right-desk-container>
					<Dropdown
						:defaultValue="'Some Opts'"
						:options="ddOptions(10)"
						v-model="dropdownValue1"
				/></template>
			</ResultsToolbar>

			<ResultsToolbar>
				<template #left-container-above>
					<Search
						variant="toggle-icons"
						:timeout="300"
						placeholder="Search by clients name or number"
					/>
					<DropdownSort
						:showClearSelectedButton="false"
						v-model="ddsValue"
						:options="ddsOptions"
					/>
				</template>
				<template #left-container-below>
					<Button
						labelText="Bulk Actions"
						class="btn--primary"
						:btnClick="() => {}"
				/></template>
				<template #counter> <ResultCounter :counter="100"/></template>
			</ResultsToolbar>
		</section>
		<section class="samples__section result toolbar">
			<h2 class="samples__title">Result Toolbar Component</h2>
			<div class="results-toolbar__toggle">
				<Toggle :value="true" variant="condensed">
					<template slot="true-value">ON</template>
					<template slot="false-value">OFF</template>
				</Toggle>
			</div>
			<br />
			<Toggle :value="true">
				<template slot="true-value">YES</template>
				<template slot="false-value">NO</template>
			</Toggle>
		</section>
		<section class="samples__section">
			<h2 class="samples__title">No Results</h2>
			<NoResults />
			<NoResults :variant="'condensed'" />
		</section>
		<section class="samples__section">
			<h2 class="samples__title">CCL Selector</h2>
			<CCLSelector :items="clients" />
		</section>

		<div id="floatingButtons">
			<Button
				:className="'btn--icon-only-circle'"
				labelText=""
				iconClassName="icon-arrow-up"
				:iconBeforeLabel="true"
				:btnClick="scrollToTop"
			/>
			<Button
				:className="'btn--icon-only-circle'"
				labelText=""
				iconClassName="icon-arrow-down"
				:iconBeforeLabel="true"
				:btnClick="scrollToEnd"
			/>
		</div>
	</div>
</template>

<script>
import Checkbox from '@/components/forms/selection-control/checkbox/checkbox';
import Radiobutton from '@/components/forms/selection-control/radiobutton/radiobutton';
import Toggle from '@/components/forms/selection-control/toggle/toggle';
import ResultCounter from '@/site-components/result-counter/result-counter';
import SelectAll from '@/site-components/select-all/select-all';
import Search from '@/components/forms/search/search';
import Table from '@/components/shells/table/table';
import Fieldset from '@/components/forms/fieldset/fieldset';
import Textarea from '@/components/forms/textarea/textarea.vue';
import Dropdown from '@/components/forms/dropdown/dropdown.vue';
import DropdownSort from '@/components/forms/dropdown/dropdown-sort';
import Bulk from '@/components/forms/bulk/bulk';
import CheckboxGroup from '@/components/forms/selection-control/checkbox/checkbox-group';
import Button from '@/components/forms/button/button';
import RadioButtonGroup from '@/components/forms/selection-control/radiobutton/radiobutton-group';
import { mapGetters, mapMutations } from 'vuex';
import SearchFinder from '@/components/forms/search/search-finder';
import SplitInput from '@/components/forms/input/split-input';
import { ApiService as api } from '@/services/axiosHelper';
import { createPatch } from 'rfc6902';
import TimePicker from '@/components/forms/time-picker/time-picker';
import FieldInput from '@/components/forms/input/field-input.vue';
import TooltipContainer from '@/components/shells/tooltip/tooltip-container.vue';
import Flyout from '@/components/shells/flyout/flyout';
import ButtonGroup from '@/components/forms/button/button-group';
import ResultsToolbar from '@/components/shells/results-toolbar/results-toolbar.vue';
import NoResults from '@/site-components/no-results/no-results';
import CCLSelector from '@/components/ccl-selector/ccl-selector.vue';

export default {
	name: 'Samples',
	components: {
		Checkbox,
		Radiobutton,
		Toggle,
		Table,
		Fieldset,
		Textarea,
		Dropdown,
		Search,
		SearchFinder,
		ResultCounter,
		SelectAll,
		DropdownSort,
		Bulk,
		CheckboxGroup,
		Button,
		RadioButtonGroup,
		SplitInput,
		TimePicker,
		FieldInput,
		TooltipContainer,
		Flyout,
		ButtonGroup,
		ResultsToolbar,
		NoResults,
		CCLSelector
	},
	computed: {
		...mapGetters('customer', ['customer']),
		jsonDataTransactionsString() {
			return JSON.stringify(this.jsonDataTransactions);
		},
		ddsValue: {
			get() {
				return {
					sortby: this.filters.sortby,
					sortdirection: this.filters.sortdirection
				};
			},
			set(value) {
				this.filters.sortby = value.sortby;
				this.filters.sortdirection = value.sortdirection;
			}
		}
	},
	created() {
		this.clients = this.generateRandomClientData(8);
	},
	methods: {
		exportCsv() {
			let rawData = {
				timestamp: '2023-05-18T14:48:40.9456854Z',
				formattedTimestamp: null,
				sourceApplication: 'VueSupport',
				entityType: 'FormRepositoryModel',
				action: 'Update',
				changedByUserId: 'a5f03509-be98-4c76-a0ea-407c78175745',
				changedByUserName: 'Alexis Echemendia Gonzalez, Jr.',
				changedEntityId: '4829',
				entityDescription: '',
				message: 'name and description test csv',
				fieldChanges: {
					items: [
						{
							Action: 'Update',
							OriginalValue: 'BPATEST NAME Updated',
							NewValue: 'BPATEST NAME CSV',
							ChangedPropertyName: 'Name'
						},
						{
							Action: 'Update',
							OriginalValue: 'Changed 04/13/2023',
							NewValue: 'Changed 04/13/2023 asdsadsada',
							ChangedPropertyName: 'Description'
						}
					]
				}
			};

			const data = [['Date/Time', 'Action', 'Changed By']];

			rawData.fieldChanges.items.forEach(change => {
				data.push([
					this.encodeCSV(rawData.timestamp),
					this.encodeCSV(change.Action),
					this.encodeCSV(rawData.changedByUserName)
				]);
			});

			for (let i = 1; i <= 10000; i++) {
				data.push([data[1][0], data[1][1], data[1][2]]);
			}

			const csvContent = data.map(row => row.join(',')).join('\n');
			const csvFilename = 'sample-export.csv';
			const blob = new Blob([csvContent], { type: 'text/csv' });

			const downloadLink = document.createElement('a');
			downloadLink.href = URL.createObjectURL(blob);
			downloadLink.download = csvFilename;
			downloadLink.click();
			URL.revokeObjectURL(downloadLink.href);
		},
		encodeCSV(value) {
			return value.includes(',') ? `"${value}"` : value;
		},
		async jsonPatchUsingCreatePath() {
			this.initialObjPatched = createPatch(
				this.initialCreatePatchObj,
				this.modifiedCreatePatchObj
			);

			console.log(this.initialObjPatched);

			const result = await api.patch(
				'demos/jsonpatch',
				this.initialObjPatched
			);
			this.jsonPatchResult = result;
		},
		ddOptions(count, objResponse) {
			let options = [];
			for (let i = 0; i < (count ? count : 3); i++) {
				let option;
				switch (objResponse) {
					case 'object':
						option = {
							text: `lorem ipsum dolor sit amet ${i}`,
							value: `${i}`
						};
						break;
					case 'number':
						option = i;
						break;
					default:
						option = `lorem ipsum dolor sit amet ${i}`;
				}

				options.push(option);
			}

			return options;
		},
		...mapMutations('customer', ['SetCustomer']),
		populateCompany() {
			const customer = {
				companyId: 'eff5664a-9377-43aa-93a7-5b99b4460076',
				dealershipGroup: 'QA Remote Data (Access2)',
				dealershipGroupNumber: 99999,
				displayName: 'Access2',
				favorite: true
			};
			this.SetCustomer(this.customer ? null : customer);
		},
		status() {
			let options = [];
			for (let i = 0; i < 3; i++) {
				const option =
					i % 2 === 0 ? 'Unlock' : i === 1 ? 'Lock' : 'Checking';
				options.push(option);
			}
			return options;
		},
		goDocumentation() {
			window.open(
				'https://innologica.github.io/vue2-daterange-picker/#example-playground',
				'_blank'
			);
		},
		selectedRow(e) {
			console.log(e);
		},
		dateFormat(classes, date) {
			if (!classes.disabled) {
				classes.disabled = date.getTime() < new Date();
			}
			return classes;
		},
		exportedCsv(e) {
			console.log(e);
			this.isExported = true;
			setTimeout(() => {
				this.isExported = false;
			}, 3 * 1000);
		},
		btnExported() {
			console.log('Exported!!');
		},
		tooltipcontainerFlyout() {
			this.showTooltipcontainerFlyout = true;
		},
		closeTooltipcontainerFlyout(e) {
			this.showTooltipcontainerFlyout = false;
			if (e) e.preventDefault();
		},
		getRandomInt(min, max) {
			return Math.floor(Math.random() * (max - min + 1)) + min;
		},

		getRandomBoolean() {
			return Math.random() < 0.5;
		},
		getRandomString(length = 5) {
			const characters =
				'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
			let result = '';
			for (let i = 0; i < length; i++) {
				result += characters.charAt(
					Math.floor(Math.random() * characters.length)
				);
			}
			return result;
		},
		generateRandomClientData(numClients) {
			const clients = [];

			for (let i = 0; i < numClients; i++) {
				const activeBetaFeature = this.getRandomBoolean();
				const companies = [];
				let numCompanies = [];

				const isEven = i % 2 === 0;

				if (isEven) {
					numCompanies = this.getRandomInt(1, 5);
					for (let j = 0; j < numCompanies; j++) {
						const locations = [];

						const numLocations = this.getRandomInt(0, 3);
						for (let k = 0; k < numLocations; k++) {
							locations.push({
								id: `${this.getRandomString(
									8
								)}-${this.getRandomString(
									4
								)}-${this.getRandomString(
									4
								)}-${this.getRandomString(
									4
								)}-${this.getRandomString(12)}`,
								companyLocationId: this.getRandomInt(1, 1000),
								locationNumber: this.getRandomInt(1, 99)
									.toString()
									.padStart(2, '0'),
								locationName: `Location ${this.getRandomString(
									80
								)}`,
								locationCode: `LOC${this.getRandomInt(
									10000000,
									99999999
								)}`,
								activeBetaFeature: this.getRandomBoolean()
							});
						}

						companies.push({
							id: `${this.getRandomString(
								8
							)}-${this.getRandomString(
								4
							)}-${this.getRandomString(
								4
							)}-${this.getRandomString(
								4
							)}-${this.getRandomString(12)}`,
							companyId: this.getRandomInt(1, 1000),
							companyNumber: this.getRandomInt(1, 99)
								.toString()
								.padStart(2, '0'),
							companyName: `Company ${this.getRandomString(80)}`,
							companyCode: `SVD${this.getRandomInt(
								10000000,
								99999999
							)}`,
							activeBetaFeature: this.getRandomBoolean(),
							locations: locations
						});
					}
				}

				clients.push({
					id: `${this.getRandomString(8)}-${this.getRandomString(
						4
					)}-${this.getRandomString(4)}-${this.getRandomString(
						4
					)}-${this.getRandomString(12)}`,
					customerNumber: this.getRandomInt(10000, 99999),
					customerName: `Display ${this.getRandomString(5)}`,
					type: null,
					activeBetaFeature: activeBetaFeature,
					companies: companies
				});
			}

			return clients;
		},
		scrollToEnd() {
			window.scrollTo({
				top: document.body.scrollHeight,
				behavior: 'smooth'
			});
		},
		scrollToTop() {
			window.scrollTo({
				top: 0,
				behavior: 'smooth'
			});
		}
	},
	data() {
		return {
			timer1: '11:00 PM',
			timer2: '07:00 AM',
			fieldInputText: 'field input example',
			initialCreatePatchObj: {
				customerName: 'Jhon',
				orders: [
					{
						orderName: 'Order1',
						orderType: 20
					}
				]
			},
			modifiedCreatePatchObj: {
				customerName: 'Barry',
				orders: [
					{
						orderName: 'Order1',
						orderType: 20
					},
					{
						orderName: 'Order2',
						orderType: 22
					}
				]
			},
			initialObjPatched: null,
			jsonPatchResult: null,
			splitInputValue: 'noname@domain.com',
			optionFieldsType: [],
			codeLookUpSelected: {},
			radiobuttonItems: [
				{
					labelText: 'Item1',
					disabled: false
				},
				{
					labelText: 'Item2',
					disabled: false
				},
				{
					labelText: 'Item3',
					disabled: true
				}
			],
			radiobuttonItem: '',
			radiobuttonItems1: [
				{
					labelText: 'Item1',
					disabled: false,
					value: 1
				},
				{
					labelText: 'Item2',
					disabled: false,
					value: 2
				},
				{
					labelText: 'Item3',
					disabled: true,
					value: 3
				}
			],
			radiobuttonItem1: 2,
			radiobuttonItems2: [
				{
					labelText: 'Item1',
					disabled: false,
					value: true
				},
				{
					labelText: 'Item2',
					disabled: false,
					value: false
				},
				{
					labelText: 'Item3',
					disabled: false,
					value: null
				}
			],
			radiobuttonItem2: undefined,
			toggleClassLabelInside: 'toggle--label-in',
			displayModelUser: false,
			message: 'Button Clicked!!!',
			messageFlyout: 'Button Cliked!!!',
			notifyCounter: 0,
			blockCounter: 0,
			cols: 30,
			rows: 10,
			maxLength: 50,
			required: true,
			viewModal: 0,
			resultButton: '',
			resultInput: {},
			resultPasswordInput: '',
			resultEmailInput: '',
			resultAutoSuggestionInput: '',
			resultButtonGroup: '',
			resultTextarea1: 'one',
			resultTextareaFlyout: '',
			labelValue: 'Label by Default',
			placeholder: 'Please enter the value',
			displayModal: false,
			checkboxItems: [
				{
					disabled: false,
					label: 'label example1',
					modelValue: '',
					value: '11'
				},
				{
					disabled: false,
					label: 'label example2',
					modelValue: '',
					value: '22'
				},
				{
					disabled: false,
					label: 'label example3',
					modelValue: '33',
					value: '33'
				},
				{
					disabled: false,
					label: 'label example4',
					modelValue: '44',
					value: '44'
				}
			],
			checkboxGroupList: ['33'],
			dropdownValue1: '1',
			dropdownValue2: '2',
			dropdownValue3: '3',
			dropdownValue4: '4',
			data: {
				headers: [
					{
						key: 'timestamp',
						label: 'Date/Time',
						sorteable: true,
						type: 'text'
					},
					{
						key: 'action',
						label: 'Action',
						sorteable: false,
						type: 'text'
					},

					{
						key: 'changedByUserName',
						label: 'changed By',
						sorteable: true,
						type: 'text'
					}
				],
				items: [
					{
						timestamp: new Date(
							'2021-03-02T14:23:26.4559692Z'
						).toLocaleString(),
						sourceApplication: 'VueSupport',
						entityType: 'SupportUserExtended',
						action: 'Update',
						changedByUserId: '67ec6bd6-2bf6-4e98-a625-5555fb0a6c47',
						changedByUserName: 'yoselin hernandez',
						changedEntityId: '9d8e560f-4cd4-4986-82ff-80e143e45789',
						originalValue: '',
						newValue: 'Admin',
						changedPropertyName: 'Role'
					},
					{
						timestamp: new Date(
							'2021-03-02T17:58:52.1845286Z'
						).toLocaleString(),
						sourceApplication: 'VueSupport',
						entityType: 'SupportUserExtended',
						action: 'Update',
						changedByUserId: '67ec6bd6-2bf6-4e98-a625-5555fb0a6c47',
						changedByUserName: 'yoselin hernandez',
						changedEntityId: 'ecbad2ca-d488-4109-ab9d-ba923378947a',
						originalValue: '',
						newValue: 'Admin',
						changedPropertyName: 'Role'
					},
					{
						timestamp: new Date(
							'2021-02-24T15:31:07.3175872Z'
						).toLocaleString(),
						sourceApplication: 'VueSupport',
						entityType: 'SupportUserExtended',
						action: 'Update',
						changedByUserId: 'b5860263-019c-49e3-b8c9-03ade3781a70',
						changedByUserName: 'yoel morales',
						changedEntityId: 'd0c8527b-3171-4e07-85f2-c12c1433c466',
						originalValue: 'Test Role',
						newValue: 'Admin',
						changedPropertyName: 'Role'
					},
					{
						timestamp: new Date(
							'2021-02-24T15:26:52.3685639Z'
						).toLocaleString(),
						sourceApplication: 'VueSupport',
						entityType: 'SupportUserExtended',
						action: 'Update',
						changedByUserId: 'd0c8527b-3171-4e07-85f2-c12c1433c466',
						changedByUserName: 'Jorge Barreto',
						changedEntityId: 'd0c8527b-3171-4e07-85f2-c12c1433c466',
						originalValue: 'Admin',
						newValue: 'Test Role',
						changedPropertyName: 'Role'
					},
					{
						timestamp: new Date(
							'2021-03-02T14:23:26.4559692Z'
						).toLocaleString(),
						sourceApplication: 'VueSupport',
						entityType: 'SupportUserExtended',
						action: 'Update',
						changedByUserId: '67ec6bd6-2bf6-4e98-a625-5555fb0a6c47',
						changedByUserName: 'yoselin hernandez',
						changedEntityId: '9d8e560f-4cd4-4986-82ff-80e143e45789',
						originalValue: '',
						newValue: 'Admin',
						changedPropertyName: 'Role'
					},
					{
						timestamp: new Date(
							'2021-03-02T17:58:52.1845286Z'
						).toLocaleString(),
						sourceApplication: 'VueSupport',
						entityType: 'SupportUserExtended',
						action: 'Update',
						changedByUserId: '67ec6bd6-2bf6-4e98-a625-5555fb0a6c47',
						changedByUserName: 'yoselin hernandez',
						changedEntityId: 'ecbad2ca-d488-4109-ab9d-ba923378947a',
						originalValue: '',
						newValue: 'Admin',
						changedPropertyName: 'Role'
					},
					{
						timestamp: new Date(
							'2021-02-24T15:31:07.3175872Z'
						).toLocaleString(),
						sourceApplication: 'VueSupport',
						entityType: 'SupportUserExtended',
						action: 'Update',
						changedByUserId: 'b5860263-019c-49e3-b8c9-03ade3781a70',
						changedByUserName: 'yoel morales',
						changedEntityId: 'd0c8527b-3171-4e07-85f2-c12c1433c466',
						originalValue: 'Test Role',
						newValue: 'Admin',
						changedPropertyName: 'Role'
					},
					{
						timestamp: new Date(
							'2021-02-24T15:26:52.3685639Z'
						).toLocaleString(),
						sourceApplication: 'VueSupport',
						entityType: 'SupportUserExtended',
						action: 'Update',
						changedByUserId: 'd0c8527b-3171-4e07-85f2-c12c1433c466',
						changedByUserName: 'Jorge Barreto',
						changedEntityId: 'd0c8527b-3171-4e07-85f2-c12c1433c466',
						originalValue: 'Admin',
						newValue: 'Test Role',
						changedPropertyName: 'Role'
					},
					{
						timestamp: new Date(
							'2021-03-02T14:23:26.4559692Z'
						).toLocaleString(),
						sourceApplication: 'VueSupport',
						entityType: 'SupportUserExtended',
						action: 'Update',
						changedByUserId: '67ec6bd6-2bf6-4e98-a625-5555fb0a6c47',
						changedByUserName: 'yoselin hernandez',
						changedEntityId: '9d8e560f-4cd4-4986-82ff-80e143e45789',
						originalValue: '',
						newValue: 'Admin',
						changedPropertyName: 'Role'
					},
					{
						timestamp: new Date(
							'2021-03-02T17:58:52.1845286Z'
						).toLocaleString(),
						sourceApplication: 'VueSupport',
						entityType: 'SupportUserExtended',
						action: 'Update',
						changedByUserId: '67ec6bd6-2bf6-4e98-a625-5555fb0a6c47',
						changedByUserName: 'yoselin hernandez',
						changedEntityId: 'ecbad2ca-d488-4109-ab9d-ba923378947a',
						originalValue: '',
						newValue: 'Admin',
						changedPropertyName: 'Role'
					},
					{
						timestamp: new Date(
							'2021-02-24T15:31:07.3175872Z'
						).toLocaleString(),
						sourceApplication: 'VueSupport',
						entityType: 'SupportUserExtended',
						action: 'Update',
						changedByUserId: 'b5860263-019c-49e3-b8c9-03ade3781a70',
						changedByUserName: 'yoel morales',
						changedEntityId: 'd0c8527b-3171-4e07-85f2-c12c1433c466',
						originalValue: 'Test Role',
						newValue: 'Admin',
						changedPropertyName: 'Role'
					},
					{
						timestamp: new Date(
							'2021-02-24T15:26:52.3685639Z'
						).toLocaleString(),
						sourceApplication: 'VueSupport',
						entityType: 'SupportUserExtended',
						action: 'Update',
						changedByUserId: 'd0c8527b-3171-4e07-85f2-c12c1433c466',
						changedByUserName: 'Jorge Barreto',
						changedEntityId: 'd0c8527b-3171-4e07-85f2-c12c1433c466',
						originalValue: 'Admin',
						newValue: 'Test Role',
						changedPropertyName: 'Role'
					}
				],
				page: 1,
				countPerPage: 12,
				totalPageCount: 8,
				totalCount: 96
			},
			data2: {
				headers: [
					{
						key: 'codeId',
						label: 'CodeId',
						sorteable: false
					},
					{
						key: 'dateTime',
						label: 'Date/Time',
						sorteable: false
					},
					{
						key: 'user',
						label: 'User',
						sorteable: false
					},
					{
						key: 'reference',
						label: 'Reference',
						sorteable: true
					},
					{
						key: 'description',
						label: 'Description',
						sorteable: true
					},
					{
						key: 'ammount',
						label: 'Amount',
						sorteable: true
					},
					{
						key: 'post',
						label: 'Post',
						sorteable: true
					}
				],
				displayHeader: true,
				source: {
					items: [
						{
							codeId: 7850,
							dateTime: '07/13/2020',
							user: 'user@dominiondms.com',
							reference: '12345',
							description: 'Lorem Ipsum',
							amount: 20,
							post: 5
						},
						{
							codeId: 8050,
							dateTime: '07/13/2020',
							user: 'user@dominiondms.com',
							reference: '12345',
							description: 'Lorem Ipsum',
							amount: 23,
							post: 1
						},
						{
							codeId: 7950,
							dateTime: '07/13/2020',
							user: 'user@dominiondms.com',
							reference: '12345',
							description: 'Lorem Ipsum',
							amount: 34,
							post: 7
						},
						{
							codeId: 7850,
							dateTime: '07/13/2020',
							user: 'user@dominiondms.com',
							reference: '12345',
							description: 'Lorem Ipsum',
							amount: 20,
							post: 5
						},
						{
							codeId: 8050,
							dateTime: '07/13/2020',
							user: 'user@dominiondms.com',
							reference: '12345',
							description: 'Lorem Ipsum',
							amount: 23,
							post: 1
						},
						{
							codeId: 7950,
							dateTime: '07/13/2020',
							user: 'user@dominiondms.com',
							reference: '12345',
							description: 'Lorem Ipsum',
							amount: 34,
							post: 7
						},
						{
							codeId: 7850,
							dateTime: '07/13/2020',
							user: 'user@dominiondms.com',
							reference: '12345',
							description: 'Lorem Ipsum',
							amount: 20,
							post: 5
						},
						{
							codeId: 8050,
							dateTime: '07/13/2020',
							user: 'user@dominiondms.com',
							reference: '12345',
							description: 'Lorem Ipsum',
							amount: 23,
							post: 1
						},
						{
							dateTime: '07/13/2020',
							user: 'user@dominiondms.com',
							reference: '12345',
							codeId: 7950,
							DateTime: '07/13/2020',
							User: 'user@dominiondms.com',
							Reference: '12345',
							Description: 'Lorem Ipsum',
							Amount: 34,
							Post: 7
						}
					],
					page: 1,
					countPerPage: 9,
					totalPageCount: 8,
					totalCount: 96
				}
			},
			form: {
				customers: [
					{
						assigned: true,

						customerId: 'c1907ab9-2a71-43b8-9d6f-165f66ef9e5d'
					},

					{
						assigned: true,

						customerId: 'eff5664a-9377-43aa-93a7-5b99b4460076'
					},

					{
						assigned: true,

						customerId: 'bb6c49f9-89ab-4e20-8c75-364e94e2012a',

						enabled: false
					}
				]
			},
			jsonDataTransactions: [
				{
					id: 1,
					timestamp: '2022-02-04T15:44:39.5577036Z',
					sourceApplication: 'SecureVue2',
					dealershipGroupNumber: 99995,
					dealershipGroupGuid: '7f4b0134-1719-4121-9242-e654d4e22b31',
					partyId: 'PID10025',
					companyId: 1,
					dealerNumberId: 'SVD9999501',
					bodType: 'ProcessPurchaseOrder',
					bodVersion: 'ppnet.1.0',
					requestUri:
						'https://qavuestore.blob.core.windows.net/vueintegrationapi/ProcessPurchaseOrderController_Request%202_4_2022%2015_44_40.0147390.xml',
					responseUri:
						'https://qavuestore.blob.core.windows.net/vueintegrationapi/ProcessPurchaseOrderController_Response%202_4_2022%2015_44_40.0164894.xml',
					level: 'INFO'
				},
				{
					id: 2,
					timestamp: '2022-02-04T15:44:39.5577036A',
					sourceApplication: 'SecureVue2',
					dealershipGroupNumber: 99996,
					dealershipGroupGuid: 'dc2c9c42-7958-486f-a44c-ec38e040713e',
					partyId: 'PID10012',
					companyId: 1,
					dealerNumberId: 'SVD9999202',
					bodType: 'ProcessPurchaseOrder',
					bodVersion: 'ppnet.1.0',
					requestUri:
						'https://qavuestore.blob.core.windows.net/vueintegrationapi/ProcessPurchaseOrderController_Request%202_4_2022%2015_44_40.0147390.xml',
					responseUri:
						'https://qavuestore.blob.core.windows.net/vueintegrationapi/ProcessPurchaseOrderController_Response%202_4_2022%2015_44_40.0164894.xml',
					level: 'INFO'
				}
			],
			csvDataFile: 'transactions_export.csv',
			transactionsColumns: {
				id: 'Id',
				timestamp: 'Timestamp',
				sourceApplication: 'Source Application',
				dealershipGroupNumber: 'Dealership Group Number',
				dealershipGroupGuid: 'Dealership Group Guid',
				partyId: 'Party Id',
				companyId: 'Company Id',
				dealerNumberId: 'Dealer Number Id',
				bodType: 'Bod Type',
				bodVersion: 'Bod Version',
				requestUri: 'Request Uri',
				responseUri: 'Response Uri',
				level: 'Level'
			},
			isExported: false,
			sourceOptions: [
				{
					name: 'manufacturer',
					label: 'Manufacturer',
					placeholder: 'Select One',
					options: [
						{ text: 'Kia', value: 1 },
						{ text: 'Volkswagen', value: 2 }
					]
				},
				{
					name: 'ordersource',
					label: 'Order Source',
					placeholder: 'Select One',
					options: [
						{ text: 'X-Kia Parts', value: 1 },
						{ text: 'O -  Non-Stock Part', value: 2 }
					]
				}
			],
			rowValues: [
				{
					manufacturer: 1,
					ordersource: 1
				},
				{
					manufacturer: 2,
					ordersource: 2
				}
			],
			showTooltipcontainerFlyout: false,
			filters: {
				sortby: 'name',
				sortdirection: 'asc'
			},
			ddsOptions: [
				{ text: 'Name', value: 'name' },
				{ text: 'Status', value: 'status' }
			],
			toggleValue: true,
			clients: []
		};
	},
	beforeMount() {
		this.$nextTick(() => {
			if (window.scrollY) {
				// reset the scroll position to the top left of the document.
				window.scroll(0, 0);
			}
			this.radiobuttonItem2 = false;
		});
	}
};
</script>

<style lang="scss" scoped>
/**
    * Samples Page
    * Can use SCSS variables = TRUE
    *
    * This should only contain classes and styles used for the page layout.
*/
.samples {
	background: $page-body-bkgd;
	@include text-contrast($page-body-bkgd, $white, $black);

	&__text {
		margin-bottom: $gutter-md;
		font-size: 14px;
	}
}

.samples__section {
	margin-bottom: $gutter-xxl;
	> .samples__title {
		margin-bottom: $gutter-lg;
		font-weight: 400;
		padding: $padding-sm $padding-md;
		@include text-contrast($black, $white, $black);
		background: $black;
		border-radius: 2px;
		letter-spacing: 1px;
		font-size: 16px;
		text-transform: capitalize;
	}
}

.samples__sub-section {
	> .samples__title {
		margin-bottom: $gutter-lg;
		font-weight: 600;
		font-size: 24px;
		text-transform: capitalize;
	}
}

/*------------------------------------*\
  #FORMS
\*------------------------------------*/
.form-test {
	margin-top: 36px;

	&__row {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		margin-bottom: 12px;
		flex-wrap: wrap;

		> .form-test__item {
			flex-basis: 150px;
			flex-grow: 1;

			&:not(:last-child) {
				margin-right: 12px;
			}
		}
	}
	&__col {
		display: inline-flex;
		flex-direction: column;
		flex-wrap: nowrap;
		flex-basis: 0;
		flex-grow: 1;

		&:not(:last-child) {
			margin-right: 12px;
		}

		> .form-test__item {
			&:not(:last-child) {
				margin-bottom: 12px;
			}
		}
	}
}

.results-toolbar.results-toolbar--variant-three .results-toolbar__filter {
	@include mq($from: md) {
		display: flex;
		gap: $gutter-lg;
	}
}

/** TEMPORARY - added styles for results toolbar variants examples. Once dev work has been applied these styles should be removed**/
.results-toolbar--variant-two,
.results-toolbar--variant-three,
.results-toolbar--variant-four,
.results-toolbar--variant-six,
.results-toolbar--variant-seven {
	.results-toolbar__filter {
		.dropdown {
			@include mq($until: md-l) {
				display: none;
			}
			display: inline;
		}
	}
}

.jsonpatch-section a {
	text-decoration: underline;
}

.jsonpatch-demo {
	display: flex;
	flex-direction: column;
	gap: $gutter-lg;

	> div {
		display: flex;
		justify-content: space-between;
		align-items: stretch;
		gap: $gutter-lg;

		> * {
			flex: 1 1 0;
			border: 1px solid gainsboro;
			padding: $padding-md;
			border-radius: 4px;
			min-height: 200px;
		}

		strong {
			display: block;
			margin-bottom: $gutter-sm;
		}
	}

	.btn--primary {
		align-self: flex-start;
	}
}

.typography-section {
	&__heading {
		&-sm {
			@include heading('sm');
		}
		&-md {
			@include heading('md');
		}
		&-lg {
			@include heading('lg');
		}
	}

	&__sub-heading {
		@include sub-heading;
	}

	&__bd-txt {
		&-sm {
			@include body-text('sm');
		}
		&-sm-supporting {
			@include body-text('sm-supporting');
		}
		&-regular {
			@include body-text('regular');
		}
		&-regular-emphasis {
			@include body-text('regular-emphasis');
		}
		&-lg {
			@include body-text('lg');
		}
	}
}

.scrollbar-section {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: $gutter-xl;
	@include body-text('regular');

	.samples__title {
		grid-column: 1 / 3;
	}

	&__default,
	&__white {
		max-height: 220px;
		overflow: auto;
	}

	&__default {
		@include scrollbar;
	}

	&__white {
		background-color: $neutral-4;
		@include scrollbar('white');
	}
}
#floatingButtons {
	position: fixed;
	right: 20px;
	bottom: 30px;
	display: flex;
	flex-direction: column;
	gap: 10px;
	z-index: 1000;
}

#floatingButtons .btn--icon-only-circle {
	width: 50px;
	height: 50px;
	border-radius: 50%;
	background-color: $accent;
	color: white;
	border: none;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
}
</style>
